// deps
import React, { ReactElement, useCallback, memo } from "react";

// styles
import { CheckboxInput, CheckboxLabel, CheckboxTick } from "./styles/Checkbox.styled";

// interfaces
import { InputFieldAttributes } from "@core-ui/interfaces/Input";

export interface CheckboxProps {
    value?: string | number;
    checked: boolean;
    onChange?: (name: string, value: string, checked: boolean) => void;
    name: string;
    accent: CHECKBOX_ACCENT;
    attrs?: InputFieldAttributes;
    isLightBorder?: boolean;
}

export enum CHECKBOX_ACCENT {
    SWIGGY_ORANGE = "SWIGGY_ORANGE",
}

const SVG_ICON_PATH = (
    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
);

function Checkbox(props: CheckboxProps): ReactElement {
    const { checked, accent, attrs = {}, onChange, isLightBorder } = props;

    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>): void => {
            const { name, value, checked } = event.target;

            if (onChange != undefined) {
                onChange(name, value, checked);
            }
        },
        [onChange],
    );

    // prevent event propogation of click on input
    const handleClick = useCallback((event: React.MouseEvent<HTMLInputElement>): void => {
        event.stopPropagation();
    }, []);

    return (
        <CheckboxLabel $accent={accent} $checked={checked} $isLightBorder={isLightBorder}>
            <CheckboxInput
                type="checkbox"
                name={props.name}
                value={props.value}
                onChange={handleChange}
                onClick={handleClick}
                checked={checked}
                {...attrs}
            />
            <CheckboxTick $checked={checked} viewBox="0 0 24 24">
                {SVG_ICON_PATH}
            </CheckboxTick>
        </CheckboxLabel>
    );
}

export default memo(Checkbox);
